export const logoImg = require("../assets/images/logo-blue.svg");
export const personIcon = require("../assets/images/person-icon.svg");
export const logoutIcon = require("../assets/images/logout-icon.svg");

export const billingIcon = require("../assets/images/billing-icon.svg");
export const billingIconActive = require("../assets/images/billing-icon-active.svg");
export const customersIcon = require("../assets/images/customers-icon.svg");
export const customersIconActive = require("../assets/images/customers-icon-active.svg");
export const profileIcon = require("../assets/images/profile-icon.svg");
export const profileIconActive = require("../assets/images/profile-icon-active.svg");
export const invoiceIcon = require("../assets/images/invoice-icon.svg");
export const invoiceIconActive = require("../assets/images/invoice-icon-active.svg");
export const plansIcon = require("../assets/images/plans-icon.svg");
export const plansIconActive = require("../assets/images/plans-icon-active.svg");

export const faceIcon = require("../assets/images/face-icon.svg");
export const crossIcon = require("../assets/images/cross-icon.svg");

export const resendInvite = require("../assets/images/resend-invite.svg");
export const resendInvite2 = require("../assets/images/resend-invite-2.svg");
export const downloadIcon = require("../assets/images/download-icon.svg");
export const crossIconRoundWhite = require("../assets/images/cross-icon-white-round.svg");
export const searchIcon = require("../assets/images/search-icon.svg");
export const rocketIcon = require("../assets/images/rocket-icon.svg");
export const loader = require("../assets/images/loading_image.gif");